import cover from "./cover_album.png";
import { useState, useRef } from "react";
import "./App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import share from './share.svg';
import spotifyBlack from './spotifyBlack.svg';
import apple from './apple.svg';
import itunes from './itunes.svg';
import amazon from './amazon.svg';
import deezer from './deezer.svg';
import follow from './follow.svg';


function App() {

    const [showAccordion, setShowAccordion] = useState(false);
    const hideTimeoutRef = useRef(null);
    let hoverTimeout;

    const handleShare = () => {
      if (navigator.share) {
        navigator.share({
          title: 'Ora Nish',
          text: 'Check out Ora Nish music!',
          url: window.location.href,
        })
        .then(() => console.log('Shared successfully'))
        .catch((error) => console.log('Error sharing', error));
      } else {
        alert('Web Share not supported on this browser.');
      }
    };

    const handleMouseOver = () => {
      clearTimeout(hoverTimeout);
      setShowAccordion(true);
    };

    const handleMouseLeave = () => {
      // Set a timeout to hide after 300ms (adjust as needed)
          hideTimeoutRef.current = setTimeout(() => {
            setShowAccordion(false);
            hideTimeoutRef.current = null;
          }, 500);



    };
  return (
    <div className="App app-wrapper">
      <header className="App-header">
        <div className="album-container position-relative">
          <img src={cover} className="App-logo" alt="logo" />
          <div className="btn-group-vertical position-absolute  m-1" id="buttonGroupNormal" style={{ top: '76%', fontSize: '18px'}} role="group" aria-label="Vertical button group">
           <div
              className="position-relative"
              onMouseEnter={() => handleMouseOver()}
              onMouseLeave={() => handleMouseLeave()}
              style={{ display: 'inline-block' }}
            >
              <button
                type="button"
                className="btn d-flex justify-content-center align-items-center follownshareButton"
                style={{
                  background: 'rgba(0, 0, 0, 0.25)',
                  color: 'white',
                  width: '120px',
                  height: '30px',
                  borderRadius: '3px',
                  border: '1px solid white',
                  marginBottom: '8px'
                }}
              >
                <img src={follow} style={{width: '20px', marginRight: '5px'}} alt="share" /> Follow
              </button>

              {showAccordion && (
                <div
                  className="accordion-dropdown"
                  
                >
                  <a href="https://www.instagram.com/ora.nish/" target="_blank" rel="noreferrer" className="d-block mb-2" style={{ color: 'white', textDecoration: 'none' }}>Instagram</a>
                  <a href="https://www.youtube.com/@oranish" target="_blank" rel="noreferrer" className="d-block mb-2" style={{ color: 'white', textDecoration: 'none' }}>Youtube</a>
                  <a href="https://www.facebook.com/oranish.music" target="_blank" rel="noreferrer" className="d-block mb-2" style={{ color: 'white', textDecoration: 'none' }}>Facebook</a>
                  <a href="https://www.tiktok.com/@ora.nish" target="_blank" rel="noreferrer" className="d-block" style={{ color: 'white', textDecoration: 'none' }}>TikTok</a>
                </div>
              )}
            </div>
              <button type="button" className="btn d-flex justify-content-center align-items-center" style={{
                background: 'rgba(0, 0, 0, 0.25)',
                color: 'white',
                width: '120px',
                height: '30px',
                borderRadius: '3px',
                border: '1px solid white',
                
              }} onClick={handleShare}><img src={share} style={{width: '20px', marginRight: '5px'}} alt="share" />Share</button>
          </div>
        </div>
        <div className="btn-group position-absolute  m-1 mt-5" id="buttonGroupHidden" style={{ top: '76%', fontSize: '18px', marginTop: '100px'}} role="group" aria-label="Vertical button group">
           <div
              className="position-relative"
              onMouseEnter={() => handleMouseOver()}
              onMouseLeave={() => handleMouseLeave()}
              style={{ display: 'inline-block' }}
            >
              <button
                type="button"
                className="btn d-flex justify-content-center align-items-center follownshareButton"
                style={{
                  background: 'rgba(0, 0, 0, 0.25)',
                  color: 'white',
                  width: '120px',
                  height: '30px',
                  borderRadius: '3px',
                  border: '1px solid white',
                  marginBottom: '8px'
                }}
              >
                <img src={follow} style={{width: '20px', marginRight: '5px'}} alt="share" /> Follow
              </button>

              
            </div>
              <button type="button" className="btn d-flex justify-content-center align-items-center" style={{
                background: 'rgba(0, 0, 0, 0.25)',
                color: 'white',
                width: '120px',
                height: '30px',
                borderRadius: '3px',
                border: '1px solid white',
                
              }} onClick={handleShare}><img src={share} style={{width: '20px', marginRight: '5px'}} alt="share" />Share</button>
          </div>
      </header>
      <main className= "app-main" style={{backgroundColor: 'rgba(136, 136, 136, 0.25)'}}>
        {showAccordion && (
                <div
                  className="accordion-dropdown"
                  id="accordionHorizontal"
                  style = {{position: 'absolute', fontSize: '18px', width: '100%', zIndex: '9999', top: '0px'}}
                  
                >
                  <a href="https://www.instagram.com/ora.nish/" target="_blank" rel="noreferrer" className="d-block mb-2" style={{ color: 'white', textDecoration: 'none' }}>Instagram</a>
                  <a href="https://www.youtube.com/@oranish" target="_blank" rel="noreferrer" className="d-block mb-2" style={{ color: 'white', textDecoration: 'none' }}>Youtube</a>
                  <a href="https://www.facebook.com/oranish.music" target="_blank" rel="noreferrer" className="d-block mb-2" style={{ color: 'white', textDecoration: 'none' }}>Facebook</a>
                  <a href="https://www.tiktok.com/@ora.nish" target="_blank" rel="noreferrer" className="d-block" style={{ color: 'white', textDecoration: 'none' }}>TikTok</a>
                </div>
              )}
        <h3 className="mt-1">Listen to Ora Nish</h3>
        <hr />
        <div class="container-fluid">
          <div class="row row-cols-1 row-cols-md-3 mt-4">
            <div className="col"><a type="button" class="btn btn-outline-dark btn-lg m-1" style={{width: '80%', fontSize: '25px'}} href="https://open.spotify.com/artist/0Ml5eWY8IRtKUwrTKdvmgF?si=mkS_SXc6T-SGwXptzSenKw"> <img src={spotifyBlack} style={{width: '25px', marginRight: '5px', marginBottom: '5px'}} alt="spotify" />Spotify</a></div>
            <div className="col"><a type="button" class="btn btn-outline-dark btn-lg m-1" style={{width: '80%', fontSize: '25px'}} href="https://music.apple.com/us/artist/ora-nish/1819081148"> <img src={apple} style={{width: '25px', marginRight: '5px', marginBottom: '5px'}} alt="apple" />Apple Music</a></div>
            <div className="col"><a type="button" class="btn btn-outline-dark btn-lg m-1 icon-button" style={{width: '80%', fontSize: '25px'}} href="https://music.youtube.com/channel/UCTPc1b-4C_dd0_lV_5huoDA?si=6whSHkjaVJUn4ifj"> <svg className="play-icon mb-1"  style={{width: '25px', marginRight: '5px', marginBottom: '5px'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="25" height="25">
              <g transform="scale(5.33333,5.33333)">
                <circle cx="24" cy="24" r="20" fill="currentColor" />
                <path className="triangle" d="M21,29l8,-5l-8,-5z" fill="#ffffff" />
                <path d="M24,14c5.5,0 10,4.476 10,10c0,5.524 -4.476,10 -10,10c-5.524,0 -10,-4.476 -10,-10c0,-5.524 4.5,-10 10,-10"
                  fill="none" stroke="currentColor" />
              </g>
            </svg>YouTube Music</a></div>
          </div>
          <div class="row row-cols-1 row-cols-md-3 mt-3 mb-3">
            <div className="col"><a type="button" class="btn btn-outline-dark btn-lg m-1" style={{width: '80%', fontSize: '25px'}} href="https://music.apple.com/au/album/ep-ep/1819081681"> <img src={itunes} style={{width: '25px', marginRight: '5px', marginBottom: '5px'}} alt="itunes" />iTunes</a></div>
            <div className="col"><a type="button" class="btn btn-outline-dark btn-lg m-1" style={{width: '80%', fontSize: '25px'}} href="https://music.amazon.com/artists/B0FC44VWFW/ora-nish"> <img src={amazon} style={{width: '25px', marginRight: '5px', marginBottom: '5px'}} alt="amazon" />Amazon</a></div>
            <div className="col"><a type="button" class="btn btn-outline-dark btn-lg m-1" style={{width: '80%', fontSize: '25px'}} href="https://www.deezer.com/en/artist/329500301"> <img src={deezer} style={{width: '25px', marginRight: '5px', marginBottom: '5px'}} alt="deezer" />Deezer</a></div>
          </div>
        </div>
      </main>
      <footer className="app-footer" style={{backgroundColor: 'rgba(136, 136, 136, 0.25)'}} >Support the artist: <a href="https://revolut.me/oranish" style={{ color: 'black'}}>Ora Nish</a>
      <br/>
      <p style ={{fontSize: '15px'}} className="mt-1">© 2025 Ora Nish</p>
      </footer>
    </div>
  );
}

export default App;
